module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"ramda","commonjs2":"ramda","amd":"ramda","root":"R"}
// module id = 4
// module chunks = 0